import React from 'react';
import './MatchCardSkeleton.css';

/* ── Match Card Skeleton (SportsPage / HomePage) ── */
export function MatchCardSkeleton() {
  return (
    <div className="mcs-card">
      <div className="mcs-header">
        <div className="mcs-bone mcs-league" />
        <div className="mcs-bone mcs-date" />
      </div>
      <div className="mcs-teams">
        <div className="mcs-team">
          <div className="mcs-bone mcs-logo" />
          <div className="mcs-bone mcs-name" />
        </div>
        <div className="mcs-bone mcs-vs" />
        <div className="mcs-team mcs-team-right">
          <div className="mcs-bone mcs-name" />
          <div className="mcs-bone mcs-logo" />
        </div>
      </div>
      <div className="mcs-odds">
        <div className="mcs-bone mcs-odd" />
        <div className="mcs-bone mcs-odd" />
        <div className="mcs-bone mcs-odd" />
      </div>
      <div className="mcs-footer">
        <div className="mcs-bone mcs-footer-btn" />
        <div className="mcs-bone mcs-footer-btn mcs-footer-btn-sm" />
      </div>
    </div>
  );
}

export function MatchGridSkeleton({ count = 6 }) {
  return (
    <div className="mcs-grid">
      {Array.from({ length: count }).map((_, i) => (
        <MatchCardSkeleton key={i} />
      ))}
    </div>
  );
}

/* ── Live Match Card Skeleton (LivePage) ── */
export function LiveCardSkeleton() {
  return (
    <div className="mcs-live-card">
      <div className="mcs-live-header">
        <div className="mcs-bone mcs-live-league" />
        <div className="mcs-bone mcs-live-badge" />
      </div>
      <div className="mcs-live-body">
        <div className="mcs-live-team">
          <div className="mcs-bone mcs-live-logo" />
          <div className="mcs-bone mcs-live-name" />
        </div>
        <div className="mcs-bone mcs-live-score" />
        <div className="mcs-live-team mcs-live-team-r">
          <div className="mcs-bone mcs-live-logo" />
          <div className="mcs-bone mcs-live-name" />
        </div>
      </div>
      <div className="mcs-live-footer">
        <div className="mcs-bone mcs-live-foot-l" />
        <div className="mcs-bone mcs-live-foot-r" />
      </div>
    </div>
  );
}

export function LiveGridSkeleton({ count = 4 }) {
  return (
    <div className="mcs-grid">
      {Array.from({ length: count }).map((_, i) => (
        <LiveCardSkeleton key={i} />
      ))}
    </div>
  );
}

/* ── Ticket Skeleton (MyBetsPage) ── */
export function TicketSkeleton() {
  return (
    <div className="mcs-ticket">
      <div className="mcs-ticket-head">
        <div className="mcs-bone mcs-t-badge" />
        <div className="mcs-bone mcs-t-type" />
        <div className="mcs-bone mcs-t-date" />
      </div>
      {[1, 2].map((i) => (
        <div className="mcs-ticket-row" key={i}>
          <div className="mcs-bone mcs-t-teams" />
          <div className="mcs-bone mcs-t-sel" />
          <div className="mcs-bone mcs-t-odd" />
        </div>
      ))}
      <div className="mcs-ticket-foot">
        <div className="mcs-bone mcs-t-stake" />
        <div className="mcs-bone mcs-t-gain" />
      </div>
    </div>
  );
}

export function TicketListSkeleton({ count = 3 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <TicketSkeleton key={i} />
      ))}
    </>
  );
}

/* ── Transaction Row Skeleton (Wallet / deposits / withdrawals) ── */
export function TransactionSkeleton() {
  return (
    <div className="mcs-tx-row">
      <div className="mcs-tx-left">
        <div className="mcs-bone mcs-tx-icon" />
        <div>
          <div className="mcs-bone mcs-tx-ref" />
          <div className="mcs-bone mcs-tx-date" />
        </div>
      </div>
      <div className="mcs-tx-right">
        <div className="mcs-bone mcs-tx-amount" />
        <div className="mcs-bone mcs-tx-badge" />
      </div>
    </div>
  );
}

export function TransactionListSkeleton({ count = 4 }) {
  return (
    <div className="mcs-tx-list">
      {Array.from({ length: count }).map((_, i) => (
        <TransactionSkeleton key={i} />
      ))}
    </div>
  );
}
